/**
 * Cabinet Interceptor — Story 21.9
 *
 * Добавляет X-Cabinet-ID заголовок ко всем запросам к /api/v1/
 * Работает в ОБОИХ режимах: Keycloak и mock auth.
 *
 * Отдельный interceptor + cache-busting URL param (Story 21.10) — держится
 * независимо от authInterceptor (который тоже добавляет X-Cabinet-ID, но
 * без cache-busting) намеренно: единая точка правды для CDN-обхода вне
 * зависимости от того, что делает Bearer/refresh-логика auth.interceptor.ts.
 */
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CabinetStateService } from '../services/cabinet-state.service';

export const cabinetInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('/api/v1/')) {
    return next(req);
  }

  const cabinetState = inject(CabinetStateService);
  const cabinetId = cabinetState.activeCabinetId();

  if (!cabinetId) {
    return next(req);
  }

  // Story 21.10: Add cache-busting param to bypass Bunny CDN caching API responses
  // CDN ignores Cache-Control: no-store headers, so unique URL per cabinet is needed
  const separator = req.url.includes('?') ? '&' : '?';
  const cacheBustUrl = `${req.url}${separator}_cab=${cabinetId.slice(0, 8)}`;

  const clonedReq = req.clone({
    url: cacheBustUrl,
    setHeaders: {
      'X-Cabinet-ID': cabinetId,
      'Cache-Control': 'no-cache, no-store',
    },
  });
  return next(clonedReq);
};
